// Dashboard App usage platforms page translations (pt-BR), loaded into dashboard.usage.platforms by ../pt-BR.usage.js
module.exports = {
  menu: "Plataformas",
  title: "Plataformas",
  description: "Sistema operativo, versões e modelos de aparelho.",
  kpis: {
    android: "Android",
    ios: "iPhone",
    topAndroid: "Android mais usado",
    topIos: "iOS mais usado",
  },
  info: {
    android: "Parte dos utilizadores ativos do período que usou a app em Android.\nFonte: Google Analytics.",
    ios: "Parte dos utilizadores ativos do período que usou a app em iPhone.\nFonte: Google Analytics.",
    topAndroid: "Versão do Android mais usada pelos utilizadores ativos do período.\nFonte: Google Analytics.",
    topIos: "Versão do iOS mais usada pelos utilizadores ativos do período.\nFonte: Google Analytics.",
  },
  hints: {
    users: "{n} utilizadores",
    ofAndroid: "{pct} dos Android",
    ofIos: "{pct} dos iPhone",
  },
  systems: {
    android: "Android",
    ios: "iPhone",
  },
  panels: {
    systems: "Sistema operativo",
    devicesSub: "aparelhos",
    android: "Versão do Android",
    ios: "Versão do iOS",
    versionTitle: "{system} {version} · {n} utilizadores",
    devices: "Top aparelhos",
    devicesNote: "Ajuda a identificar bugs específicos por modelo.",
    crashes: "Crashes por aparelho Android",
    crashesNote: "Erros da app (app_exception) registados pelo Firebase.",
  },
  panelInfo: {
    systems: "Utilizadores ativos do período por sistema operativo.\nFonte: Google Analytics.",
    android: "Utilizadores ativos do período por versão do Android.\nFonte: Google Analytics.",
    ios: "Utilizadores ativos do período por versão do iOS.\nFonte: Google Analytics.",
    devices: "Modelos de aparelho com mais utilizadores ativos no período.\nFonte: Google Analytics.",
    crashes: "Erros da app (app_exception) por aparelho Android no período.\nFonte: Google Analytics (evento app_exception).",
  },
};
